<template>
  <div class="contentTitle">
    <span class="line"/>
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "contentTitle",
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style lang="less" scoped>
.contentTitle {
  margin-bottom: 20px;

  .line {
    border-left: 4px solid #009fd9;
    height: 20px;
  }

  & > span:last-of-type {
    font-weight: bold;
    font-size: 16px;
    margin-left: 10px;
  }
}
</style>